import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import servicesData from '../data/servicesData';
import { handleLinkClick } from '../utils/deviceUtils';

import images from '../assets/index';
import '../styles/SubServiceDetail.css';

const caseStudiesData = [
    {
        title: "Building a Trusted Data Foundation for Financial Services",
        image: images.newcase1,
        to: "/case-studies/financial-services",
    },
    {
        title: "Modernizing Compliance & Reporting with Data at Scale",
        image: images.newcase2,
        to: "/case-studies/banking",
    },
    {
        title: "Unified Data for Smarter Insurance Decisions",
        image: images.newcase3,
        to: "/case-studies/insurance",
    },
    {
        title: "A Single Customer View for Better Airline Experiences",
        image: images.newcase4,
        to: "/case-studies/airline",
    },
];

const SubServiceDetailPage = () => {
    const { serviceSlug, subSlug } = useParams();
    const service = servicesData.find(s => s.slug === serviceSlug);
    const subService = service?.subServices?.find(sub => {
        const generatedSlug = sub.title
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/,/g, '')
            .replace(/&/g, 'and')
            .replace(/[()]/g, '');

        return generatedSlug === subSlug;
    });

    useEffect(() => {
        if (subService) {
            document.title = `${subService.title} | Datamatics Consulting`;
        } else {
            document.title = 'Service Not Found | Datamatics Consulting';
        }
    }, [subService]);

    if (!service) {
        return <div className="not-found-sub">Service not found</div>;
    }
    if (!subService) {
        return <div className="not-found-sub">Sub Service not found</div>;
    }

    return (
        <div className="subservice-page-sub">

            {/* Top Heading */}
            <section className="subservice-header-sub container">
                <div className="subservice-title-wrapper-sub">
                    <div className="purple-line-sub"></div>
                    <h5>{subService.title}</h5>
                </div>
                <h1 className="main-heading-sub">
                    {subService.heroTitle}
                </h1>
                <p className="description-sub">
                    {subService.heroDescription}
                </p>
            </section>

            {/* Bullet Points */}
            <section className="bullets-section-sub container">
                <ul>
                    {subService.bullets?.map((point, index) => (
                        <li key={index}>{point}</li>
                    ))}
                </ul>
            </section>

            {/* Image + Card Section */}
            <section className="info-section-sub container">
                {[1, 2, 3, 4].map((num) => {
                    const card = subService[`card${num}`];
                    if (!card) return null;
                    return (
                        <div key={num} className="info-grid-sub">
                            <div className="image-container-sub">
                                <img
                                    src={card.image}
                                    alt={card.title || "Service illustration"}
                                    style={{
                                        width: '420px',
                                        height: '300px',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                            <div className="content-box-sub">
                                <h2>{card.title}</h2>
                                <p>{card.description}</p>
                            </div>
                        </div>
                    );
                })}
            </section>

            {/* Case Studies Section */}
            <section className="case-studies-section container">
                <div className="case-studies-header">
                    <div className="purple-line-sub"></div>
                    <span className="case-studies-label">Also view Case Studies</span>
                </div>
                <div className="case-studies-grid">
                    {caseStudiesData.slice(0, 3).map((study, index) => (
                        <div
                            key={index}
                            className="case-study-card"
                            onClick={() => handleLinkClick(study.to)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="case-study-image-wrapper">
                                <img src={study.image} alt={study.title} />
                            </div>
                            <h3 className="case-study-title">{study.title}</h3>
                            <a href={study.to} className="case-study-read-more" onClick={(e) => { e.preventDefault(); handleLinkClick(study.to); }}>
                                Read More →
                            </a>
                        </div>
                    ))}
                </div>
            </section>

            {/* Bottom Banner */}
            <section className="bottom-banner-sub">
                <img src={images.code2} alt="Future of Data" />
                <div className="bottom-banner-overlay-sub">
                    <h2>The Future doesn't run on Code — It runs on DATA</h2>
                </div>
            </section>
        </div>
    );
};

export default SubServiceDetailPage;